// Форматирование чисел, денег и времени для интерфейса.
import { NB, S } from './strings';

const intFmt = new Intl.NumberFormat(S.units.locale, { maximumFractionDigits: 0 });

/** «149 ₽», «1 500 ₽» — с неразрывными пробелами. */
export function rub(n: number): string {
  return `${intFmt.format(Math.round(n)).replace(/\s/g, NB)}${NB}₽`;
}

/** «10 с» */
export function secs(n: number): string {
  return `${Math.round(n)}${NB}${S.units.sec}`;
}

/** Сколько ждать: «меньше минуты», «≈ 3 мин». */
export function etaText(sec: number): string {
  if (!Number.isFinite(sec) || sec <= 60) return S.units.lessThanMinute;
  return S.units.aboutMin(Math.ceil(sec / 60));
}

/** «12,4 тыс.» / «987» / «1,2 млн» */
export function compactCount(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) {
    const v = n < 10_000 ? Math.round(n / 100) / 10 : Math.round(n / 1000);
    return `${String(v).replace('.', ',')}${NB}${S.units.thousand}`;
  }
  const v = Math.round(n / 100_000) / 10;
  return `${String(v).replace('.', ',')}${NB}${S.units.million}`;
}

/** Таймкод камеры «00:01:23». */
export function timecode(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  const p = (x: number) => String(x).padStart(2, '0');
  return `${p(h)}:${p(m)}:${p(r)}`;
}

/** «сегодня, 14:05», «вчера», «12 окт» */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const startOfDay = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOfDay(now) - startOfDay(d)) / 86_400_000);
  const hm = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  if (diffDays === 0) return `${S.units.today}, ${hm}`;
  if (diffDays === 1) return `${S.units.yesterday}, ${hm}`;
  const sameYear = d.getFullYear() === now.getFullYear();
  return `${d.getDate()}${NB}${S.units.months[d.getMonth()]}${sameYear ? '' : ` ${d.getFullYear()}`}`;
}
